'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShopParameters = function () {
    //

    function ShopParameters(data) {
        (0, _classCallCheck3.default)(this, ShopParameters);
        this.params = null;

        (0, _assign2.default)(this, data);

        this.normalizeParams();
    }

    (0, _createClass3.default)(ShopParameters, [{
        key: 'normalizeParams',
        value: function normalizeParams() {
            var params = this.params;

            if (typeof params === 'string') {
                try {
                    params = JSON.parse(params);
                } catch (e) {}
            }

            if ((typeof params === 'undefined' ? 'undefined' : (0, _typeof3.default)(params)) === 'object') {
                var nParams = [];
                for (var key in params) {
                    params[key].slug = key;
                    nParams.push(params[key]);
                }

                params = nParams;
            }

            this.params = Array.isArray(params) ? params : [];
        }
    }]);
    return ShopParameters;
}();

exports.default = ShopParameters;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/Models/lib/ShopParameters.js
// module id = 1587
// module chunks = 0